import React from 'react';
import './Spinner.css';
const spinner = (props)=> {
    return (
        <div className="loader" style={{width: props.width , height: props.height}}>Loading...</div>

    )
}

export default spinner;